export function GiftPassCardHeading({ title, detail }: { title: string; detail: string }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 8,
        padding: '12px 16px',
        borderBottom: '1px solid var(--nb-border)',
      }}
    >
      <h2 className="nb-display" style={{ margin: 0, fontSize: 15, color: 'var(--nb-bark-dark)' }}>
        {title}
      </h2>
      <span style={{ fontSize: 11.5, color: 'var(--nb-subtle)' }}>{detail}</span>
    </div>
  );
}
